import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/headless/indicators/indicators.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
